module.exports = __webpack_public_path__ + "static/media/bakery-business.8b4dd82a.jpg";